<template>
  <div class="tags-view-container" v-if="tagsView.visitedViews.length">
    <div class="tags-view-wrapper" ref="scrollPane">
      <router-link
        v-for="tag in tagsView.visitedViews"
        ref="tag"
        :key="tag.path"
        :class="['tags-view-item', { active: isActive(tag) }]"
        :to="{ path: tag.path, query: tag.query }"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        <span class="tags-view-item-title">{{ tag.title }}</span>
        <span
          v-if="!tagsView.isFixedHome(tag.path)"
          class="el-icon-close tags-view-item-close"
          @click.prevent.stop="closeTag(tag)"
        ></span>
      </router-link>
    </div>

    <!-- 右键菜单 -->
    <ul
      v-show="visible"
      :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="context-menu"
    >
      <li @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags">关闭全部</li>
    </ul>
  </div>
</template>

<script>
import tagsView from '@/utils/tagsView'

export default {
  name: 'TagsView',
  data() {
    return {
      tagsView,
      visible: false,
      menuTop: 0,
      menuLeft: 0,
      selectedTag: {}
    }
  },
  computed: {
    currentRoute() {
      return this.$route
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.addEventListener('click', this.closeMenu)
      } else {
        document.removeEventListener('click', this.closeMenu)
      }
    },
    $route: {
      handler() {
        this.addTags()
        this.moveToCurrentTag()
      },
      immediate: false
    }
  },
  mounted() {
    this.addTags()
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },

    addTags() {
      const route = this.$route
      if (route.name) {
        tagsView.addView(route)
      }
    },

    moveToCurrentTag() {
      const tags = this.$refs.tag
      if (!tags) return
      this.$nextTick(() => {
        const container = this.$refs.scrollPane
        if (!container) return
        const currentTag = Array.from(tags).find(tag => {
          return tag.to && tag.to.path === this.$route.path
        })
        if (currentTag) {
          currentTag.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
      })
    },

    closeTag(view) {
      tagsView.removeView(view)
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    toLastView() {
      const lastView = tagsView.toLastView(this.$route)
      if (lastView) {
        this.$router.push(lastView.fullPath)
      } else {
        this.$router.push(tagsView.fixedHomePath)
      }
    },

    openMenu(tag, e) {
      this.menuLeft = e.clientX
      this.menuTop = e.clientY
      this.visible = true
      this.selectedTag = tag
    },

    closeMenu() {
      this.visible = false
    },

    closeSelectedTag(view) {
      tagsView.removeView(view)
      this.closeMenu()
      if (this.isActive(view)) {
        this.toLastView()
      }
    },

    closeOthersTags() {
      tagsView.closeOthers(this.selectedTag)
      this.closeMenu()
      if (!this.isActive(this.selectedTag)) {
        this.$router.push(this.selectedTag.fullPath)
      }
    },

    closeAllTags() {
      tagsView.closeAll()
      this.closeMenu()
      this.$router.push(tagsView.fixedHomePath)
    }
  }
}
</script>

<style scoped>
.tags-view-container {
  height: auto;
  width: 100%;
  background-color: transparent;
  border-bottom: none;
  box-shadow: none;
  position: relative;
  margin-bottom: 16px;
}

.tags-view-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 4px 8px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15,23,42,0.04), 0 0 0 1px #e3e5ec;
}

.tags-view-wrapper::-webkit-scrollbar {
  height: 3px;
}
.tags-view-wrapper::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 3px;
}

.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 16px;
  margin: 0 6px 0 0;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  background-color: #f0f1f5;
  border: none;
  border-radius: 20px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  position: relative;
}

.tags-view-item:hover {
  color: #5865f2;
  background-color: #eef0fa;
  transform: translateY(-1px);
}

.tags-view-item.active {
  color: #ffffff;
  background: linear-gradient(135deg, #5865f2 0%, #7680f5 100%);
  box-shadow: 0 2px 8px rgba(88, 101, 242, 0.3);
  font-weight: 600;
}

.tags-view-item.active::after {
  display: none;
}

.tags-view-item-title {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tags-view-item-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  margin-left: 6px;
  font-size: 10px;
  transition: all 0.2s;
}

.tags-view-item.active .tags-view-item-close {
  color: rgba(255,255,255,0.7);
}

.tags-view-item.active .tags-view-item-close:hover {
  background-color: rgba(255, 255, 255, 0.25);
  color: #fff;
}

.tags-view-item:not(.active) .tags-view-item-close:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: #303133;
}

/* 右键菜单 */
.context-menu {
  position: fixed;
  z-index: 10001;
  margin: 0;
  padding: 6px 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.1), 0 0 0 1px #e3e5ec;
  list-style: none;
  min-width: 130px;
  border: none;
  overflow: hidden;
}

.context-menu li {
  padding: 10px 22px;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  transition: all 0.15s;
}

.context-menu li:hover {
  color: #5865f2;
  background-color: #eef0fa;
}

/* ============ Dark Theme ============ */
.main-layout-wrapper[data-theme="dark"] .tags-view-wrapper {
  background: #1a1a2e;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2), 0 0 0 1px #2a2a3e;
}

.main-layout-wrapper[data-theme="dark"] .tags-view-item {
  color: #a0a5b8;
  background-color: #252540;
  border: none;
}

.main-layout-wrapper[data-theme="dark"] .tags-view-item:hover {
  color: #7cb8f8;
  background-color: #2d2d50;
}

.main-layout-wrapper[data-theme="dark"] .tags-view-item.active {
  color: #ffffff;
  background: linear-gradient(135deg, #5b4fcf 0%, #7cb8f8 100%);
  box-shadow: 0 2px 8px rgba(91, 79, 207, 0.4);
}
.main-layout-wrapper[data-theme="dark"] .tags-view-item.active::after {
  display: none;
}

.main-layout-wrapper[data-theme="dark"] .context-menu {
  background: #1a1a2e;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5), 0 0 0 1px #2a2a3e;
}

.main-layout-wrapper[data-theme="dark"] .context-menu li {
  color: #a0a5b8;
}

.main-layout-wrapper[data-theme="dark"] .context-menu li:hover {
  color: #7cb8f8;
  background-color: #252545;
}
</style>
